module.exports = __webpack_public_path__ + "img/28_27.a4917002.png";